import React, { useEffect, useState } from 'react';
import request from '../../../services/Request';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import BackButton from '../../items/buttons/BackButton';
import { userLimits } from '../uitls/userLimits';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import AlertCustomModal from './AlertCustomModal';
import { Box, Typography, Chip, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import EmailIcon from '@mui/icons-material/Email';

const getAlertURL = `/logs/alertCustom/`;

export default function AlertCustom(props) {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [theData, setTheData] = useState(true);
  const [data, setData] = useState([]);
  const [reFresh, setReFresh] = useState(false);
  const { id, tableTitle } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Alert Messages',
    'view_report'
  );

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_alert_custom')
      ? localStorage.getItem('table_view_alert_custom')
      : 20
  );

  useEffect(() => {
    localStorage.setItem('table_view_alert_custom', pagination);
  }, [pagination]);

  useEffect(() => {
    request({
      method: 'get',
      url: getAlertURL + id,
    }).then((res) => {
      setLoading(true);
      console.log(res.data);
      setData(res.data);
    });
  }, [reFresh]);

  const columns = [
    {
      title: 'Message Code',
      field: 'code',
      render: (rowData) => (
        <Typography
          variant="body2"
          sx={{ fontFamily: 'monospace', fontWeight: 700, color: theme.palette.primary.main }}
        >
          {rowData.code}
        </Typography>
      ),
    },
    {
      title: 'Message Text',
      field: 'text',
      render: (rowData) => (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            color: rowData.color || theme.palette.text.primary,
          }}
        >
          {rowData.text}
        </Typography>
      ),
    },
    {
      title: 'Email Alert',
      field: 'alert',
      render: (rowData) => (
        <Chip
          icon={<EmailIcon sx={{ fontSize: 16 }} />}
          label={rowData.alert || 'None'}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: rowData.alert
              ? alpha(theme.palette.success.main, 0.12)
              : alpha(theme.palette.grey[500], 0.12),
            color: rowData.alert ? theme.palette.success.dark : theme.palette.text.secondary,
            border: `1.5px solid ${
              rowData.alert
                ? alpha(theme.palette.success.main, 0.3)
                : alpha(theme.palette.grey[500], 0.3)
            }`,
            '& .MuiChip-icon': {
              color: rowData.alert ? theme.palette.success.dark : theme.palette.text.secondary,
            },
          }}
        />
      ),
    },
  ];
  return (
    <ModernPageContainer>
      {!loading && <LoadingIcon />}

      <ModernPageHeader
        title={tableTitle || 'Alert Messages'}
        subtitle="Configure custom alert messages and email notifications"
        icon={NotificationsActiveIcon}
      />

      <Box sx={{ mt: 3 }}>
        <ModernTable
          onRowsPerPageChange={setPagination}
          columns={columns}
          data={data}
          actions={[
            {
              icon: 'edit',
              tooltip: 'Edit Alert',
              onClick: (event, rowData) => {
                setTheData(rowData);
                setShow(true);
              },
            },
          ]}
          options={{
            pageSize: parseInt(pagination),
            pageSizeOptions: [10, 20, 50, 100, 200],
            actionsColumnIndex: -1,
          }}
        />
        <Box sx={{ mt: 2 }}>
          <BackButton />
        </Box>
      </Box>

      <AlertCustomModal
        data={theData}
        show={show}
        id={id}
        setReFresh={setReFresh}
        reFresh={reFresh}
        onHide={() => setShow(false)}
      />
    </ModernPageContainer>
  );
}
